import Blockquote from '@tiptap/extension-blockquote';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ContentBlockQuoteView } from './content-block-quote-view';

export const ContentBlockquote = Blockquote.extend({
  addNodeView() {
    return ReactNodeViewRenderer(ContentBlockQuoteView);
  },
  draggable: true,
});
